// Helpers over the 2025 post-merger ward catalog (see wards-2025.generated.ts).
// The picker flow: province Select (VN_PROVINCES_2025) → ward Select
// (getWardsForProvince). Ward auto-fill comes from the server's
// point-in-polygon resolution (WardsService) — these helpers only back the
// editable dropdown and code→name lookups.

import {
  VN_PROVINCES_2025,
  VN_WARDS_2025,
  type VnProvince2025,
  type VnWard2025,
} from "./wards-2025.generated";

// province code → its wards, built once at module load.
const WARDS_BY_PROVINCE = (() => {
  const m = new Map<string, VnWard2025[]>();
  for (const w of VN_WARDS_2025) {
    const list = m.get(w.p);
    if (list) list.push(w);
    else m.set(w.p, [w]);
  }
  return m;
})();

const WARD_BY_CODE = new Map(VN_WARDS_2025.map((w) => [w.c, w]));
const PROVINCE_2025_BY_CODE = new Map(
  VN_PROVINCES_2025.map((p) => [p.code, p]),
);

export function getWardsForProvince2025(
  provinceCode: string | null | undefined,
): readonly VnWard2025[] {
  if (!provinceCode) return [];
  return WARDS_BY_PROVINCE.get(provinceCode) ?? [];
}

export function findWard2025(
  wardCode: string | null | undefined,
): VnWard2025 | null {
  if (!wardCode) return null;
  return WARD_BY_CODE.get(wardCode) ?? null;
}

export function findProvince2025(
  provinceCode: string | null | undefined,
): VnProvince2025 | null {
  if (!provinceCode) return null;
  return PROVINCE_2025_BY_CODE.get(provinceCode) ?? null;
}
